// gets the GA name for a route
export function getPageType(routeName) {
    if (['home', 'sku', 'brands', 'mmy', 'search'].includes(routeName)) return routeName
    if (['checkout', 'cart', 'address', 'payment', 'receipt'].includes(routeName)) return 'checkout'
    if (routeName.includes('product')) return 'product-line'
    if (routeName.includes('specials')) return 'specials'
    if (routeName.includes('brand')) return 'brand'
    if (routeName.includes('category')) return 'category'
    return 'other'
}
